import React from 'react';

import { InboxItemContentResources, InboxItemContentWrapper } from 'src/components/inboxItem';
import { InboxLayoutEmployerManager } from 'src/layouts/InboxLayout';

export const InboxEmployerManager: React.FC = () => {
  return (
    <InboxLayoutEmployerManager>
      <InboxItemContentWrapper statusBar={null}>
        <InboxItemContentResources />
      </InboxItemContentWrapper>
    </InboxLayoutEmployerManager>
  );
};
